import { FilterBlockWrapper } from './FilterBlockWrapper';
import { ArrangePopupWrapper } from './ArrangePopupWrapper';

export function ArrangeFilterPopupWrapper({ children }) {
  return <ArrangePopupWrapper filter={<FilterBlockWrapper>{children}</FilterBlockWrapper>} />;
}
